/**
 * One element of StudioLayer.Sublayers, as gis.SublayersJson builds it in
 * v2-features-db. Configuration is the sublayer's own config blob; absent on
 * a catalog that predates the export carrying it, in which case the editor
 * starts empty and an empty save keeps whatever is stored.
 */
export type StudioSublayer = {
  Key: string
  Thumbnail: string | null
  Priority: number
  IsEnabled: boolean
  CreatedAt: string | null
  Language: Record<
    string,
    { Name?: string | null; Description?: string | null }
  > | null
  Configuration?: Record<string, unknown> | null
}

export function readStudioSublayers(value: unknown): StudioSublayer[] {
  if (!Array.isArray(value)) return []
  return value.filter(
    (item): item is StudioSublayer =>
      typeof item === "object" &&
      item !== null &&
      typeof (item as StudioSublayer).Key === "string",
  )
}
